<template>
    <div class="btn-group page-nav " role="group">
        <div class="dropdown show">
            <a class="btn dropdown-toggle"
                :class="{ 'active': (this.$route.name === 'courses') || (this.$route.name === 'demandes') }" href="#"
                role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa-solid fa-money-bill-transfer"></i> Courses
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <router-link class="dropdown-item" :to="{ name: 'courses' }">
                    Programmes
                </router-link>
                <router-link class="dropdown-item" :to="{ name: 'demandes' }">
                    Demandes
                </router-link>

            </div>
        </div>

        <router-link class="btn" :to="{ name: 'paiements' }" :class="{ 'active': this.$route.name === 'paiements' }">
            <i class="fa-solid fa-money-bill-transfer"></i> Paiements
        </router-link>

        <router-link class="btn" :to="{ name: 'programmes' }" :class="{ 'active': this.$route.name === 'programmes' }">
            <i class="fa-solid fa-calendar"></i> Calendrier
        </router-link>
        <router-link class="btn" :to="{ name: 'adresses' }" :class="{ 'active': this.$route.name === 'adresses' }">
            <i class="fa-solid fa-map-marker-alt"></i> Adresses
        </router-link>

    </div>
</template>
